// 预订换房
import { DateType } from '@/utils/date';
import { ReserveExchangeAction } from '@/redux/actions/reservation/constant';
import {
  RentTimeInfo,
  ConfigRoomPrice,
  RoomCategory,
  RoomExchangeType,
  SourceChannelFullInfo,
  ExchangeRentRoomInfo,
} from './base.d';

// 公共信息
export interface CommonInfo {
  exchangeType: RoomExchangeType;
  mainOrderId?: string; // 主单id
  recNo?: string; // 子订单id
  businessDate?: DateType; // 所在营业日
  ownerWYId?: string; // 预订人网鱼id
  memberLevel?: number; // 预订人会员等级
}

// 房间标识
export enum RoomSymbol {
  Block = -99, // 待排房
}

export interface MainState {
  commonInfo: CommonInfo; // 基础信息
  rentTimeInfo: RentTimeInfo; // 入住日期
  channelInfo: SourceChannelFullInfo; // 客源渠道
  rentRoomInfos: ExchangeRentRoomInfo[]; // 入住房信息
}

export interface ReducerState extends MainState {
  isInit: boolean; // 初始化
  isLoading: boolean; // 加载中
  isModify: boolean; // 是否有修改
  allRoomList: RoomCategory[]; // 可选房间
  roomPriceList: ConfigRoomPrice[]; // 房价信息
  marketPriceList: ConfigRoomPrice[]; // 市场价信息
}

const initialState: Partial<ReducerState> = {
  isInit: false,
  isLoading: true,
  isModify: false,
  commonInfo: {
    exchangeType: RoomExchangeType.KeepSame,
  },
};

type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;

const reducerMap = {
  [ReserveExchangeAction.initDefaultState]: <ActionHandler<Partial<ReducerState>>>((
    state,
    { payload },
  ) => {
    return { ...state, ...payload };
  }),
  [ReserveExchangeAction.setLoadingStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isLoading: payload };
  }),
  [ReserveExchangeAction.setInitStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isInit: payload };
  }),
  [ReserveExchangeAction.setModifyStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isModify: payload };
  }),
  [ReserveExchangeAction.setCommonData]: <ActionHandler<CommonInfo>>((state, { payload }) => {
    const { commonInfo } = state;
    return { ...state, commonInfo: { ...commonInfo, ...payload } };
  }),
  [ReserveExchangeAction.setAllRoomList]: <ActionHandler<RoomCategory[]>>((state, { payload }) => {
    return { ...state, allRoomList: payload };
  }),
  [ReserveExchangeAction.setRentRoomList]: <ActionHandler<ExchangeRentRoomInfo[]>>((
    state,
    { payload },
  ) => {
    return { ...state, rentRoomInfos: payload };
  }),
  [ReserveExchangeAction.setRoomPriceList]: <ActionHandler<ConfigRoomPrice[]>>((
    state,
    { payload },
  ) => {
    return { ...state, roomPriceList: payload };
  }),
  [ReserveExchangeAction.setMarketPriceList]: <ActionHandler<ConfigRoomPrice[]>>((
    state,
    { payload },
  ) => {
    return { ...state, marketPriceList: payload };
  }),
};

export const reducerMapper = (state = initialState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(<ReducerState>state, action);
  }
  return state;
};

export const storeName = 'reserveExchange';
